import type { DisciplinePaymentLink } from '../../interfaces'
import type { DisciplinePaymentLinksStore } from './interfaces'

import { DisciplinePaymentLinksTab, DisciplinePaymentOption } from '../../enums'

export const getters = {
  isLoading: (state: DisciplinePaymentLinksStore): boolean => state.loading,
  getProducts: (state: DisciplinePaymentLinksStore): DisciplinePaymentLinksStore['products'] => state.products,
  getPaymentOption: (state: DisciplinePaymentLinksStore): DisciplinePaymentLinksStore['paymentOption'] => state.paymentOption,
  isOneTime: (state: DisciplinePaymentLinksStore): boolean => state.paymentOption === DisciplinePaymentOption.OneTime,
  isInstallment: (state: DisciplinePaymentLinksStore): boolean => state.paymentOption === DisciplinePaymentOption.Installment,
  isAutoRenew: (state: DisciplinePaymentLinksStore): boolean => state.autoRenew,
  getPackageId: (state: DisciplinePaymentLinksStore): DisciplinePaymentLinksStore['packageId'] => state.packageId,
  getInstallmentId: (state: DisciplinePaymentLinksStore): DisciplinePaymentLinksStore['installmentId'] => state.installmentId,
  getDiscount: (state: DisciplinePaymentLinksStore): DisciplinePaymentLinksStore['discount'] => state.discount,
  getExpiresAt: (state: DisciplinePaymentLinksStore): DisciplinePaymentLinksStore['expiresAt'] => state.expiresAt,
  isCalculating: (state: DisciplinePaymentLinksStore): boolean => state.calculating,
  getCalculationError: (state: DisciplinePaymentLinksStore): DisciplinePaymentLinksStore['calculationError'] => state.calculationError,
  getOrderCalculation: (state: DisciplinePaymentLinksStore): DisciplinePaymentLinksStore['orderCalculation'] => state.orderCalculation,
  getSubscriptionCalculation: (
    state: DisciplinePaymentLinksStore,
  ): DisciplinePaymentLinksStore['subscriptionCalculation'] => state.subscriptionCalculation,
  isGenerating: (state: DisciplinePaymentLinksStore): boolean => state.generating,
  getCurrentLink: (state: DisciplinePaymentLinksStore): DisciplinePaymentLink | null =>
    state.links.find(link => link.option === state.paymentOption) ?? null,
  isPricingPageTab: (state: DisciplinePaymentLinksStore): boolean => state.linksTab === DisciplinePaymentLinksTab.PricingPage,
  getSenders: (state: DisciplinePaymentLinksStore): DisciplinePaymentLinksStore['senders'] => state.senders,
  isSending: (state: DisciplinePaymentLinksStore): boolean => state.sending,
}
